module.exports = __webpack_public_path__ + "static/media/maindoor.22017870.png";